import { render, staticRenderFns } from "./Email-templates.vue?vue&type=template&id=497c2ce8"
import script from "./Email-templates.vue?vue&type=script&lang=js"
export * from "./Email-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports